"use client"
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { IoLogoLinkedin, IoMdArrowDropdown } from "react-icons/io";
import Modal from '../general-component/Modal';
import logo from '../../../public/educaficlogowhite.png';
import SigninAdmin from '../signin-admin/signinadmin';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [signinOpen, setIsSigninOpen] = useState(false);
 
  const socialIcons = [
    { href: 'https://www.facebook.com/EducaficbyAcademically', label: <FaFacebookF className='text-[20px]' /> },
    { href: 'https://www.instagram.com/educafic.academically?igsh=cWMxaWZ5MzRjYjJx', label: <FaInstagram className='text-[20px]' /> },
    { href: 'https://www.youtube.com/@EducaficByAcademically', label: <FaYoutube className='text-[20px]' /> },
    { href: 'https://www.linkedin.com/company/study-abroad-by-academically/', label: <IoLogoLinkedin className='text-[20px]' /> }
  ];

  const columns = [
    {
      title: 'Company',
      links: [
        { href: '/about-us', label: 'About us' },
        { href: '/destination', label: 'Destinations' },
        { href: "#", label: 'Sign in as Admin', onClick: () => setIsSigninOpen(true) }
      ],
    },
    {
      title: 'Countries',
      links: [
        { href: '/destination', label: 'Australia' },
        { href: '/destination', label: 'New Zealand' },
        { href: '/destination', label: 'Ireland' },
        { href: '/destination', label: 'Canada' },
        { href: '/destination', label: 'UK' },
        { href: '/destination', label: 'USA' },
      ],
    },
    {
      title: 'Study MBBS Countries',
      links: [
        
          { href: "/study-mbbs-in-australia", label: "Australia" },
          { href: "/study-mbbs-in-canada", label: "Canada" },
          { href: "/study-mbbs-in-georgia", label: "Georgia" },
          { href: "/study-mbbs-in-kazakhstan", label: "Kazakhstan" },
          { href: "/study-mbbs-in-kyrgyzstan", label: "Kyrgyzstan" },
          { href: "/study-mbbs-in-philippines", label: "Philippines" },
          { href: "/study-mbbs-in-russia", label: "Russia" },
          { href: "/study-mbbs-in-ukraine", label: "Ukraine" },
          { href: "/study-mbbs-in-usa", label: "USA" },
          { href: "/study-mbbs-in-china", label: "China" },
          { href: "/study-mbbs-in-bangladesh", label: "Bangladesh" },
          { href: "/study-mbbs-in-nepal", label: "Nepal" },
          { href: "/study-mbbs-in-uzbekistan", label: "Uzbekistan" },
          { href: "/study-mbbs-in-poland", label: "Poland" },
          { href: "/study-mbbs-in-armenia", label: "Armenia" },
      ]
    },
    {
      title: 'Support',
      links: [
        { href: '/faqs', label: 'FAQ' },
        { href: '/disclaimer', label: 'Disclaimer' },
        { href: '/privacy-policy', label: 'Privacy Policy' },
        { href: '/terms-of-use', label: 'Terms of Use' },
        { href: '/policy', label: 'Policies' },
      ],
    },
    {
      title: 'Contact Info',
      links: [
        { href: 'tel:+919084723916', label: '+91-9084723916' },
        { href: 'tel:+919084723916', label: '+91-7055205171' },
        { href: 'mailto:studyabroad@educafic.com', label: 'studyabroad@educafic.com' },
        {
          href: '#',
          label: (
            <>
              <span className="font-bold text-[#0fb995] text-base">India</span>: Plot A2, IT Park, Sahastradhara Rd, Doon IT Park, Siddcul, Dehradun, Uttarakhand 248001
            </>
          ),
        },
        {
          href: '#',
          label: (
            <>
              <span className="font-bold text-[#0fb995] text-base">Australia</span>: Suite 207A/30 Campbell St, Blacktown NSW 2148
            </>
          ),
        },
      ],
    },
  ];

  const [openIndexes, setOpenIndexes] = useState<boolean[]>(new Array(columns.length).fill(false));

  const toggleDropdown = (index: number) => {
    setOpenIndexes((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <footer className="bg-[#0F0A37] text-white p-10 z-50 relative">
      <div className="container mx-auto px-4">
        {/* Desktop View */}
        <div className="hidden xl:grid grid-cols-2 xl:grid-cols-6  gap-8  text-center md:text-left ">
          {/* Column 1 */}
          <div className="flex flex-col items-start ">
            <div className="mb-4 pl-4">
              <Image src={logo} alt="Logo" width={120} height={120} />
            </div>
            <p className="text-xs md:text-sm   font-light sm:p-5">
              Educafic is the Study Abroad division of Academically, specializing in helping aspiring doctors, dentists, pharmacists, nurses and other healthcare professionals enroll in top courses and universities across the globe.
            </p>
          </div>

          {/* Dynamic Columns */}
          {columns.map((column, index) => (
            <div key={index}>
              <h4 className="font-semibold mb-4">{column.title}</h4>
              {column.title==="Study MBBS Countries"? (
                  <ul className="grid grid-cols-2 gap-4">
                  {column.links.map((link, index) => (
                    <li key={index}>
                      <Link href={link.href} className="text-sm font-light hover:text-[#0fb995] transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>) :
              (<ul className="space-y-2">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.onClick ? (
                      <button
                        onClick={link.onClick}
                        className="text-sm font-light underline cursor-pointer bg-transparent border-none text-white"
                      >
                        {link.label}
                      </button>
                    ) : (
                      <Link href={link.href} className="text-sm font-light hover:text-[#0fb995] transition-colors">
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
                
                {column.title === "Contact Info" && (
                  <div className='flex gap-4'>
                    {socialIcons.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          href={link.href}
                          className="text-sm font-light hover:text-[#0fb995] transition-colors"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </div>
                )}
              </ul>)}
            </div>
          ))}
          
         
</div>
        {/* Tablet View */}
        <div className='hidden xl:hidden md:block'>
          <div className="flex flex-col justify-items-start pl-4 pr-0 pb-4">
            <div className="mb-4">
              <Image src={logo} alt="Logo" width={200} height={200} />
            </div>
            <p className="text-xs md:text-sm md:text-justify font-light sm:pr-20">
              Educafic is the Study Abroad division of Academically, specializing in helping aspiring doctors, dentists, pharmacists, nurses and other healthcare professionals enroll in top courses and universities across the globe.
            </p>
          </div>

          <div className="grid grid-cols-2 pl-4 justify-evenly gap-y-8">
            {columns.map((column, index) => (
              <div key={index}>
                <h4 className="font-semibold mb-4">{column.title}</h4>
                {column.title==="Study MBBS Countries"? (
                  <ul className="grid grid-cols-2 gap-2 w-[60%]">
                  {column.links.map((link, index) => (
                    <li key={index}>
                      <Link href={link.href} className="text-sm font-light hover:text-[#0fb995] transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>) :
               ( <ul className="space-y-5">
                  {column.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      {link.onClick ? (
                        <button
                          onClick={link.onClick}
                          className="text-sm font-light underline cursor-pointer bg-transparent border-none text-white"
                        >
                          {link.label}
                        </button>
                      ) : (
                        <Link href={link.href} className="text-sm font-light hover:text-[#0fb995] transition-colors">
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                  {column.title === "Contact Info" && (
                    <div className='flex gap-4'>
                      {socialIcons.map((link, linkIndex) => (
                        <li key={linkIndex}>
                          <Link
                            href={link.href}
                            className="text-sm font-light hover:text-[#0fb995] transition-colors"
                          >
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </div>
                  )}
                </ul>)}
              </div>
            ))}
          </div>
       
    

        </div>

        {/* Mobile View */}
        <div className="md:hidden flex flex-col items-center justify-center">
          <div className='mb-6'>
            <Image src={logo} alt="Logo" width={200} height={200} />
          </div>

          {columns.map((column, index) => (
            <div key={index} className='mb-5 mt-0 justify-center items-center w-full'>
              <div 
                className="flex items-center justify-center cursor-pointer gap-3" 
                onClick={() => toggleDropdown(index)}
              >
                <span className="text-xl font-semibold">{column.title}</span>
                <span className={`${openIndexes[index] ? 'rotate-0' : 'rotate-180'} text-2xl mb-1 text-gray-500 -mt-1`}>
                  <IoMdArrowDropdown />
                </span>
              </div>

              {openIndexes[index] && (
                <div className="flex flex-col mt-4 items-center justify-center w-full">
                  <ul className="space-y-5 w-full text-center">
                    {column.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link.onClick ? (
                          <button
                            onClick={link.onClick}
                            className="text-sm font-light underline cursor-pointer bg-transparent border-none text-white"
                          >
                            {link.label}
                          </button>
                        ) : (
                          <Link href={link.href} className="text-sm font-light hover:text-[#0fb995] transition-colors">
                            {link.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}



          {/* Social Icons for Mobile */}
          <div className="flex flex-row items-center justify-center gap-8 mb-6 mt-4">
            {socialIcons.map((link, linkIndex) => (
              <div key={linkIndex}>
                <Link
                  href={link.href}
                  className="text-sm font-light hover:text-[#0fb995] transition-colors"
                >
                  {link.label}
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* Divider for desktop */}
        <hr className="hidden md:block my-8 border-t border-white/30" />

        {/* Footer Bottom Text */}
        <p className="text-center text-base md:text-sm font-bold md:font-light mt-4">
          All rights reserved 2025
        </p>
      </div>

      {isModalOpen && <Modal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}
      {signinOpen && <SigninAdmin signinOpen={signinOpen} setIsSigninOpen={setIsSigninOpen} />}
    </footer>
  );
};

export default Footer;